import config from '../config.json';

export const dev  = config.dev;
export const prod  = config.prod;
export const appConfig = config;
export default (__DEV__ ? dev : prod);

